import { logError } from 'shared'
import { apiRoutes } from 'shared/constants/routes'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { getErrorWithFullMessage, showBlob } from 'shared/utils/helpers'
import axios from '../axios'

import {
	ISddEnrollmentInitiate,
	ICompleteSddEnrollmentRequest,
	IResendOtpRequest,
} from 'selfServicePortal/interfaces/i-api-sdd'

interface IPartyId {
	partyId: string
}

const sddService = {
	// async sddGetRequest(requestType: string) {
	// 	const data = await axios
	// 		.get(requestType, await getHeadersWithJwtToken())
	// 		.then((response) => {
	// 			return response
	// 		})
	// 		.catch((error) => {
	// 			logError(error)
	// 			throw getErrorWithFullMessage(error)
	// 		})
	// 	return data
	// },

	async sddCustomerEligible(partyId: string) {
		const data = await axios
			.get(
				apiRoutes.getSddIsEligible(partyId),
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async sddCustomerMandate(partyId: string) {
		const data = await axios
			.get(
				apiRoutes.getSddMandate(partyId),
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async getSddMandateDocument(
		mandateDocumentId: string,
		windowRef: Window | null
	) {
		let data = await axios
			.get(apiRoutes.getSddMandateDocument(mandateDocumentId), {
				...(await getHeadersWithJwtToken()),
				responseType: 'blob',
			})
			.then((response) => {
				let blob = new Blob([response.data], {
					type: 'application/pdf',
				})
				showBlob(blob, windowRef, mandateDocumentId + '.pdf')
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async sddEnrollmentInitiate(enrollmentData: ISddEnrollmentInitiate) {
		let data = await axios
			.post(
				apiRoutes.sddEnrollmentInitiate,
				enrollmentData,
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async sddEnrollmentComplete(enrollmentData: ICompleteSddEnrollmentRequest) {
		let data = await axios
			.post(
				apiRoutes.sddEnrollmentComplete,
				enrollmentData,
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async sddResendOtp(enrollmentData: IResendOtpRequest) {
		let data = await axios
			.post(
				apiRoutes.sddResendOtp,
				enrollmentData,
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async getSddActivePct(country: string) {
		const data = await axios
			.get(
				apiRoutes.getSddActivePct(country),
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async getSddIbans(partyId: string) {
		const data = await axios
			.get(apiRoutes.getSddIbans(partyId), await getHeadersWithJwtToken())
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},

	async disableMandate(partyId: IPartyId) {
		let data = await axios
			.post(
				apiRoutes.sddMandateDisable,
				partyId,
				await getHeadersWithJwtToken()
			)
			.then((response) => {
				return response
			})
			.catch((error) => {
				logError(error)
				throw getErrorWithFullMessage(error)
			})
		return data
	},
}

export default sddService
